import { Preferences } from '@capacitor/preferences';

export interface DownloadCheckpoint {
	videoId: string;
	downloadedBytes: number;
	totalSize: number;
	lastUpdate: number;
	filePath: string;
}

/**
 * Save download checkpoint for resume capability
 */
export async function saveCheckpoint(videoId: string, checkpoint: DownloadCheckpoint): Promise<void> {
	try {
		await Preferences.set({
			key: `download_checkpoint_${videoId}`,
			value: JSON.stringify(checkpoint)
		});
		console.log(`💾 Checkpoint saved: ${videoId} - ${checkpoint.downloadedBytes}/${checkpoint.totalSize} bytes`);
	} catch (error) {
		console.error('Error saving checkpoint:', error);
	}
}

/**
 * Load download checkpoint
 */
export async function loadCheckpoint(videoId: string): Promise<DownloadCheckpoint | null> {
	try {
		const { value } = await Preferences.get({ key: `download_checkpoint_${videoId}` });
		if (value) {
			const checkpoint = JSON.parse(value) as DownloadCheckpoint;
			console.log(`📂 Checkpoint loaded: ${videoId} - ${checkpoint.downloadedBytes}/${checkpoint.totalSize} bytes`);
			return checkpoint;
		}
		return null;
	} catch (error) {
		console.error('Error loading checkpoint:', error);
		return null;
	}
}

/**
 * Clear download checkpoint after successful download
 */
export async function clearCheckpoint(videoId: string): Promise<void> {
	try {
		await Preferences.remove({ key: `download_checkpoint_${videoId}` });
		console.log(`🗑️ Checkpoint cleared: ${videoId}`);
	} catch (error) {
		console.error('Error clearing checkpoint:', error);
	}
}

/**
 * Get all checkpoints (for recovery on app restart)
 */
export async function getAllCheckpoints(): Promise<Array<DownloadCheckpoint>> {
	try {
		const { keys } = await Preferences.keys();
		const checkpoints: Array<DownloadCheckpoint> = [];
		
		for (const key of keys) {
			if (key.startsWith('download_checkpoint_')) {
				const { value } = await Preferences.get({ key });
				if (value) {
					checkpoints.push(JSON.parse(value) as DownloadCheckpoint);
				}
			}
		}
		
		return checkpoints;
	} catch (error) {
		console.error('Error getting all checkpoints:', error);
		return [];
	}
}
